import { render } from "./FeedbackDialog.vue?vue&type=template&id=4a901722"
import script from "./FeedbackDialog.vue?vue&type=script&lang=js"
export * from "./FeedbackDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Microsoft VS Code Project\\mft_stock_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__